import { AreaId } from './SearchSuggestionsTownsAndCities.types';

import {
    LandingPageCoast,
    LandingPageCity,
    LandingPagePopular,
    LandingPageRural
} from '@zoopla/assets';

export const sectionIcon = (id: AreaId) => {
    switch (id) {
        case 'in-the-city':
            return LandingPageCity;
        case 'on-the-coast':
            return LandingPageCoast;
        case 'rural-and-countryside':
        case 'trending-areas':
            return LandingPageRural;
        case 'popular-locations':
            return LandingPagePopular;
        default:
            return undefined;
    }
};
